import type {Iso8601DateTime} from "@vesta/common-type-definitions/typeDefinitions";
import {DateTime} from "luxon";

export function generateSqlToHumanFriendlyMonthsBetweenRange(startDate: Iso8601DateTime, endDate: Iso8601DateTime): {[key: string]: string} {
    const monthsObject: {[key: string]: string} = {};

    let startDateLuxon = DateTime.fromISO(startDate, {setZone: true});
    const endDateLuxon = DateTime.fromISO(endDate, {setZone: true});

    while (startDateLuxon.startOf("day") <= endDateLuxon.startOf("day")) {
        monthsObject[`${startDateLuxon.month.toString().padStart(2, "0")}-${startDateLuxon.year}`] = `${startDateLuxon.monthShort} ${startDateLuxon.year}`;

        startDateLuxon = startDateLuxon.plus({month: 1});
    }

    return monthsObject;
}
